$(document).on('turbolinks:load', function () {

    $('.pipeline-graphic').on('click', function () {
        var graphic = JSON.parse($(this).attr('graphic'));
        var popup = $(this).attr('popup');
        console.log(popup);
        console.log(graphic);
        if (graphic.graphic_type == "link") {
            $('.link-popup-container').show();

        } else if (graphic.graphic_type == "popup") {
            $('.image-popup-container').show();
            $('.popup-image').attr("src", popup);
        }
    })
    $('.modal-close').on('click', function () {
        $('.image-popup-container').hide()
        $('.link-popup-container').hide()
    })

    $('.close-button').on('click', function () {
        $('.image-popup-container').hide()
        $('.link-popup-container').hide()
    })

    $('.more-info-btn').on('click', function () {
        var infolink = JSON.parse($(this).attr('infolink'));

        $('.link-popup-container').show()
        $('.popup-link').attr('href', infolink.linkref)
    })
})
